import { useEffect } from 'react';

import { MemberPerksTabs } from './Dashboard/MemberPerks/MemberPerksTabs/MemberPerksTabs';

export function RewardsPage() {
  useEffect(() => {
    document.title = 'Member Perks - BeenVerified';
  }, []);

  return <MemberPerksTabs />;
}
